
<div class="cp-bind mobile">
  <Select :options="zoneList" :close="closeZone" class="select1" @select="setZone" @toggle="val => closeRole = val"></Select>
  <Select :options="roleList" :close="closeRole" class="select2" @select="setRole" @toggle="val => closeZone = val"></Select>
  <div v-if="showDownload" class="input">暂无角色信息，请下载游戏并创建角色</div>
  <div class="btns" :class="{two: showDownload}">
    <div class="button" @click="bindRole"></div>
    <a v-if="showDownload && !ingame" href="javascript:;" class="button downloadbtn ios" target="_self" @click="iosHandler"></a>
    <a v-if="showDownload" href="javascript:;" class="button downloadbtn android" target="_self" @click="downloadHandler"></a>
  </div>
  <Close is-mobile @close="handleClose" class="close"></Close>
</div>
